/**
 *Created by jmmartinez on 14/5/19
 *
 * v.2.0 30/09/2020 Cambiado a framework2
 * v.2.1 13/10/2021 En getDerivedStatedFromProps se ha añadido newState.time= getTimeFromFormattedString(nextProps.hora);
 *
 * v.2.2 04/05/2022 Unión Side,ur - Planifikator*/

import React from 'react'
import PropTypes from 'prop-types';

import "@blueprintjs/core/lib/css/blueprint.css";
import { TimePicker, TimePrecision } from "@blueprintjs/datetime";
import {getTimeFromFormattedString, getFormattedTimeFromTimestampWithFormat} from "../ej2/utils/DateUtils";


class TimeInput extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            hora: props.hora,
            time: getTimeFromFormattedString(props.hora)
        }
    }

    //Para sustituir a WillṔrops
    static getDerivedStateFromProps(nextProps, prevState){
        const newState = {};

        if( nextProps.hora !== prevState.hora){
            newState.hora= nextProps.hora;
            newState.time= getTimeFromFormattedString(nextProps.hora);
        }

        if (Object.keys(newState).length > 0)
            return newState;
        else
            return null;
    }


    onChange = (time) => {
        const {onChange, formatoHora} = this.props;
        let formatoHoraReal= formatoHora ? formatoHora : "HH:mm:ss";
        let hora= getFormattedTimeFromTimestampWithFormat(formatoHoraReal, time);
        this.setState({time:time});
        onChange && onChange(hora);
    }


    render() {
        const {time} = this.state;
        return (
            <TimePicker
                precision={TimePrecision.MINUTE}
                selectAllOnFocus={false}
                value={time}
                onChange={ (time) => this.onChange(time)}
            />
        );
    }
}


TimeInput.propTypes = {
    formatoHora: PropTypes.string,
    hora: PropTypes.string,

}

export default TimeInput;